import React from "react";
import { motion } from "motion/react";
import { Badge } from "../../ui/Badge";
import AnimatedCounter from "./AnimatedCounter";

const MetricsSection = ({ successMetrics }) => {
  return (
    <section className="py-5 bg-white">
      <div className="container px-3">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-5"
        >
          <Badge className="mb-2 bg-primary text-white border-0">
            Our Success Story
          </Badge>
          <h2 className="display-6 fw-bold mb-3 text-primary">
            Proven Track Record of Excellence
          </h2>
          <p className="lead text-muted fw-500 mb-4">
            Behind every number is a success story real results driven by
            strategy, innovation, and a deep commitment to our clients’ growth.
            Here's how MetaFox Tech is making an impact.
          </p>
        </motion.div>

        <div className="row row-cols-2 row-cols-md-4 g-4">
          {successMetrics.map((metric, index) => {
            const Icon = metric.icon;
            return (
              <motion.div
                key={metric.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="text-center"
              >
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-3 mb-3"
                  style={{
                    width: "4rem",
                    height: "4rem",
                    background: "rgba(59,130,246,0.1)",
                  }}
                >
                  <Icon className="text-primary" size={32} />
                </div>
                <h3 className="display-5 fw-bold mb-1">
                  <AnimatedCounter end={metric.number} suffix={metric.suffix} />
                </h3>
                <p className="text-muted">{metric.label}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MetricsSection;
